import { render, staticRenderFns } from "./PromotionAdd.vue?vue&type=template&id=2fffd660&scoped=true&"
import script from "./PromotionAdd.vue?vue&type=script&lang=js&"
export * from "./PromotionAdd.vue?vue&type=script&lang=js&"
import style0 from "./PromotionAdd.vue?vue&type=style&index=0&id=2fffd660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fffd660",
  null
  
)

export default component.exports